<template>
<div class="chapter">
<div class="inner_page">
<div>
<div id="_idContainer000">
<div class="Basic-Graphics-Frame">
<img alt="9781488087028.jpg" height="100%" src="image/9781488087028.jpg"/>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Cover.vue?7c093216